module.exports = __webpack_public_path__ + "img/NCHSLogo@3x.b80cee1b.png";